module.exports = __webpack_public_path__ + "static/img/3.5dd7361.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpeg
// module id = S2rr
// module chunks = 1